/**
 * This is a search page and the URL will be /search
 */
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import { getPageContent } from "../../utils";

import { selectSearchData, selectSearchStatus, selectSearchError, initializeAsync } from "./searchSlice";

import { Box, AppBar, Toolbar, Stack } from "@mui/material";

import Grid from "@mui/material/Unstable_Grid2";
import GoogleAutoComplete from "../../components/GoogleAutoComplete";

import Location from "../../components/Location";
import Map from "../../components/Map";
import "./style.css";

import Filters from "../../components/Filters";
import { config, styles } from "../../style";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { getAddress } from "../../services/google";
import { getLocation } from "../../services/google";
import { parse } from "date-fns";
import { el } from "date-fns/locale";

let intervalValue;
let propertyCount = 0;

/**
 * This is the search component
 * This is the parent component for the Autocomplete, Map amd location
 * This will also communicate with the server and fetch the data.
 * @returns
 */
const Search = () => {
    const data = useSelector(selectSearchData);
    const status = useSelector(selectSearchStatus);
    const error = useSelector(selectSearchError);
    const dispatch = useDispatch();
    let { market } = useParams();
    const navigate = useNavigate();
    const isDesktop = useMediaQuery({ minWidth: 1180 });
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1179 });
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const isPortrait = useMediaQuery({ orientation: "landscape" });
    let [searchParams, setSearchParams] = useSearchParams();
    const search = searchParams.get("search");

    const getParsedFilterParams = () => {
        let baths = searchParams.get("baths");
        let beds = searchParams.get("beds");
        let leaseProducts = searchParams.get("leaseProducts");
        let price = searchParams.get("price");
        let status = searchParams.get("status");
        let lotSizeMin = searchParams.get("lotSizeMin") ? searchParams.get("lotSizeMin") : undefined;
        let lotSizeMax = searchParams.get("lotSizeMax") ? searchParams.get("lotSizeMax") : undefined;
        let squareFtMin = searchParams.get("squareFtMin") ? searchParams.get("squareFtMin") : undefined;
        let squareFtMax = searchParams.get("squareFtMax") ? searchParams.get("squareFtMax") : undefined;
        let storiesMin = searchParams.get("storiesMin") ? searchParams.get("storiesMin") : undefined;
        let storiesMax = searchParams.get("storiesMax") ? searchParams.get("storiesMax") : undefined;
        let yearBuiltMin = searchParams.get("yearBuiltMin") ? parseInt(searchParams.get("yearBuiltMin")) : undefined;
        let yearBuiltMax = searchParams.get("yearBuiltMax") ? parseInt(searchParams.get("yearBuiltMax")) : undefined;

        let filterParams = {};

        if (baths) {
            filterParams.bathsFilter = baths;
        }
        if (beds) {
            filterParams.bedsFilter = beds;
        }
        if (leaseProducts) {
            filterParams.leaseProduct = leaseProducts.split(",");
        }
        if (price) {
            filterParams.priceFilter = price.split(",");
        }
        if (status) {
            filterParams.status = status.split(",");
        }

        if (lotSizeMin && lotSizeMax) {
            filterParams.lotSize = { min: lotSizeMin, max: lotSizeMax };
        } else if (lotSizeMin) {
            filterParams.lotSize = { min: lotSizeMin };
        } else if (lotSizeMax) {
            filterParams.lotSize = { max: lotSizeMax };
        }

        if (squareFtMin && squareFtMax) {
            filterParams.squareFt = { min: squareFtMin, max: squareFtMax };
        } else if (squareFtMin) {
            filterParams.squareFt = { min: squareFtMin };
        } else if (squareFtMax) {
            filterParams.squareFt = { max: squareFtMax };
        }

        if (storiesMin && storiesMax) {
            filterParams.stories = { min: storiesMin, max: storiesMax };
        } else if (storiesMin) {
            filterParams.stories = { min: storiesMin };
        } else if (storiesMax) {
            filterParams.stories = { max: storiesMax };
        }

        if (yearBuiltMin && yearBuiltMax) {
            filterParams.yearBuilt = { min: yearBuiltMin, max: yearBuiltMax };
        } else if (yearBuiltMin) {
            filterParams.yearBuilt = { min: yearBuiltMin };
        } else if (yearBuiltMax) {
            filterParams.yearBuilt = { max: yearBuiltMax };
        }
        return filterParams;
    };

    const filterRef = useRef(getParsedFilterParams());

    const getSortOptions = () => {
        return [
            {
                value: "newest",
                label: "Newest",
                field: "yearBuilt",
                order: "desc",
            },
            {
                value: "price-low-to-high",
                label: "Price (low to high)",
                field: "listRent",
                order: "asc",
            },
            {
                value: "price-high-to-low",
                label: "Price (high to low)",
                field: "listRent",
                order: "desc",
            },
            {
                value: "square-feet",
                label: "Square feet",
                field: "squareFeet",
                order: "desc",
            },
        ];
    };
    const zoomLevel = 5; //localStorage.getItem("map-zoom-level");

    const [location, setLocation] = useState();
    const [filters, setFilters] = useState({});
    const [zoom, setZoom] = useState(5);
    const [mapref, setMapRef] = React.useState(null);
    const [coordinates, setCordinaties] = useState({ lat: 32.779167, lng: -96.808891 });
    const [properties, setProperties] = useState([]);
    const [selectedListing, setSelectedListing] = useState();
    const [mepRefresh, setMepRefresh] = useState({});
    const [selectedSorting, setSelectedSorting] = React.useState(getSortOptions()[1]);
    const [selectedMarketRecord, setSelectedMarketRecord] = React.useState();

    const [displayLocations, setDisplayLocations] = React.useState(false);

    const mapInstanceRef = useRef(null);

    const selectedMarketRecordRef = useRef(null);

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync({}));
        }
        let lastLocation = localStorage.getItem("lastLocation");
        if (search === "true") {
            lastLocation = JSON.parse(lastLocation);
            setCordinaties(lastLocation.geometry.location);
            setLocation(lastLocation);
        } else {
            getAddress(32.779167, -96.808891).then((result) => {
                localStorage.setItem("lastLocation", JSON.stringify(result?.results[0]));
                setLocation(result?.results[0]);
            });
            setCordinaties({ lat: 32.779167, lng: -96.808891 });
        }
    }, [status, dispatch]);

    const handleMapLocationChange = (result) => {
        setProperties(result);
        propertyCount = result.length;
    };

    const setMarketLocation = async () => {
        if (market) {
            let selectedMarket = data?.markets.find((item) => item.name === market || item.id === market);
            let location = await getLocation(selectedMarket.geoLocationName);
            localStorage.setItem("lastLocation", JSON.stringify(location));
            setCordinaties(location.geometry.location);
            setLocation(location);
        }
    };

    const getZoomLevel = (records, mapData, selectedMarket, skipFilter, location) => {
        if (selectedMarket) {
            let selectedMarketRecord = data?.markets.find(
                (item) => item.geoLocationName === selectedMarket || item.id === selectedMarket
            );
            //selectedMarketRecordRef.current = selectedMarketRecord;
            let filteredRecords;
            if (!skipFilter) {
                filteredRecords = records.filter((item) => {
                    return selectedMarketRecord.shortName.toLowerCase().indexOf(item.market?.toLowerCase()) > -1;
                });
            }
            if (filteredRecords?.length > 0) {
                var bounds = new window.google.maps.LatLngBounds();
                for (let marker of filteredRecords) {
                    var temp = new window.google.maps.LatLng(marker.propertyLat, marker.propertyLng);
                    bounds.extend(temp);
                }

                mapData.setCenter(bounds.getCenter()); //or use custom center
                mapData.fitBounds(bounds);
                mapData.setZoom(mapData.getZoom() - 1);
                return -1;
            } else {
                if (!skipFilter) {
                    mapData.setZoom(12);
                }
                mapData.setCenter(location);
                return 12;
            }
        }

        return 5;
    };

    const handleSelectedLocation = (result, selectedMarket) => {
        localStorage.removeItem("map-zoom-level");
        localStorage.setItem("lastLocation", JSON.stringify(result));
        setLocation(result);
        setCordinaties(result.geometry.location);
        setTimeout(() => {
            mapref.setZoom(5);
            setSelectedMarketRecord({ location: result.geometry.location, selectedMarket: selectedMarket });
            let zoomLevel = getZoomLevel(getRecords(), mapref, selectedMarket, null, result.geometry.location);
            if (zoomLevel > -1) {
                setZoom(zoomLevel);
                mapref.setZoom(zoomLevel);
            }
        }, 1000);
    };

    const handleMapRef = (value) => {
        setMapRef(value);
        setMarketLocation(value);
        setTimeout(() => {
            value.setZoom(5);
            let zoomLevel = getZoomLevel(getRecords(), value, market);
            if (zoomLevel > -1) {
                setZoom(zoomLevel);
            }

            setDisplayLocations(true);
        }, 1000);
    };

    const handleMarkerSelect = (listing) => {
        setSelectedListing(listing);
    };
    useEffect(() => {
        if (filterRef.current && data?.markets) {
            let selectedMarket = data?.markets.find((item) => item.name === filterRef.current.market);
            selectedMarketRecordRef.current = selectedMarket;
        }
    }, [filterRef.current]);

    useEffect(() => {
        if (market && data?.markets) {
            let selectedMarket = data?.markets.find((item) => item.id === market);
            selectedMarketRecordRef.current = selectedMarket;
        }
    }, [market, data?.markets]);

    const generateFilterParams = () => {
        let filterParams = { ...filterRef.current };
        let params = [];
        if (filterParams.bathsFilter) {
            params.push("baths=" + filterParams.bathsFilter);
        }
        if (filterParams.bedsFilter) {
            params.push("beds=" + filterParams.bedsFilter);
        }
        if (filterParams.leaseProduct?.length > 0) {
            params.push("leaseProducts=" + filterParams.leaseProduct.join(","));
        }
        if (filterParams.priceFilter?.length > 0) {
            params.push("price=" + filterParams.priceFilter.join(","));
        }
        if (filterParams.status?.length > 0) {
            params.push("status=" + filterParams.status.join(","));
        }

        if (filterParams.lotSize) {
            if (filterParams.lotSize.min) {
                params.push("lotSizeMin=" + filterParams.lotSize.min);
            }
            if (filterParams.lotSize.max) {
                params.push("lotSizeMax=" + filterParams.lotSize.max);
            }
        }
        if (filterParams.squareFt) {
            if (filterParams.squareFt.min) {
                params.push("squareFtMin=" + filterParams.squareFt.min);
            }
            if (filterParams.squareFt.max) {
                params.push("squareFtMax=" + filterParams.squareFt.max);
            }
        }
        if (filterParams.stories) {
            if (filterParams.stories.min) {
                params.push("storiesMin=" + filterParams.stories.min);
            }
            if (filterParams.stories.max) {
                params.push("storiesMax=" + filterParams.stories.max);
            }
        }
        if (filterParams.yearBuilt) {
            if (filterParams.yearBuilt.min) {
                params.push("yearBuiltMin=" + filterParams.yearBuilt.min);
            }
            if (filterParams.yearBuilt.max) {
                params.push("yearBuiltMax=" + filterParams.yearBuilt.max);
            }
        }
        let selectedMarket = data?.markets.find((item) => item.name === filterParams.market);
        let env = process.env.REACT_APP_ENV ? "/" + process.env.REACT_APP_ENV : "";
        if (params?.length > 0) {
            navigate(env + "/listing-search/markets/" + selectedMarket.id + "?" + params.join("&"));
        } else {
            navigate(env + "/listing-search/markets/" + selectedMarket.id);
        }
    };

    const handleFilterChange = (filters) => {
        setFilters(filters);
        filterRef.current = filters;
        generateFilterParams();
        console.log("filterRef.current", filterRef.current);
        setTimeout(() => {
            //mapref.setZoom(5);
            mepRefresh.onRefresh(getRecords());
            if (selectedMarketRecord) {
                let zoomLevel = getZoomLevel(
                    getRecords(),
                    mapref,
                    selectedMarketRecord.selectedMarket,
                    null,
                    selectedMarketRecord.location
                );
                if (zoomLevel > -1) {
                    setZoom(zoomLevel);
                }
            }
        }, 100);
    };

    const sortRecords = (records) => {
        let sortingValue = selectedSorting;
        records.sort((a, b) => {
            let dataA = a[sortingValue.field] ? a[sortingValue.field] : "";
            let dataB = b[sortingValue.field] ? b[sortingValue.field] : "";
            dataA = dataA ? dataA : "";
            dataB = dataB ? dataB : "";
            dataA = isNaN(dataA) ? 0 : Number(dataA);
            dataB = isNaN(dataB) ? 0 : Number(dataB);
            let comparison = 0;
            if (dataA > dataB) {
                comparison = 1;
            } else if (dataA < dataB) {
                comparison = -1;
            }
            return sortingValue.order === "desc" ? comparison * -1 : comparison;
        });

        return [...records];
    };

    const getRecords = () => {
        if (data?.records?.length > 0) {
            let records = [...data.records];

            if (selectedMarketRecordRef.current) {
                console.log("selectedMarketRecord", selectedMarketRecordRef.current);
                console.log("records", records);
                records = records.filter((item) => {
                    return selectedMarketRecordRef.current.shortName.indexOf(item.market) > -1;
                });
            }
            if (selectedListing) {
                records = [selectedListing, ...records.filter((item) => item.id !== selectedListing.id)];
            }

            if (filterRef.current) {
                if (filterRef.current?.priceFilter?.length > 0) {
                    records = records.filter(
                        (item) =>
                            filterRef.current.priceFilter[0] <= item.listRent &&
                            item.listRent <= filterRef.current.priceFilter[1]
                    );
                }

                if (filterRef.current.bedsFilter) {
                    records = records.filter((item) => item.bedrooms >= parseInt(filterRef.current.bedsFilter));
                }

                if (filterRef.current.bathsFilter) {
                    records = records.filter((item) => item.baths >= parseInt(filterRef.current.bathsFilter));
                }

                if (filterRef.current.amenityAndFeatures) {
                    records = records.filter((item) => {
                        if (item.amenityAndFeatures?.length > 0) {
                            for (let amenity of item.amenityAndFeatures) {
                                if (filterRef.current.amenityAndFeatures.indexOf(amenity.name) > -1) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    });
                }

                if (filterRef.current.squareFt) {
                    if (filterRef.current.squareFt.min && filterRef.current.squareFt.max) {
                        records = records.filter(
                            (item) =>
                                item.squareFeet >= parseInt(filterRef.current.squareFt.min) &&
                                item.squareFeet <= parseInt(filterRef.current.squareFt.max)
                        );
                    } else if (filterRef.current.squareFt.min) {
                        records = records.filter((item) => item.squareFeet >= parseInt(filterRef.current.squareFt.min));
                    } else if (filterRef.current.squareFt.max) {
                        records = records.filter((item) => item.squareFeet <= parseInt(filterRef.current.squareFt.max));
                    }
                }
                if (filterRef.current.lotSize) {
                    if (filterRef.current.lotSize.min && filterRef.current.lotSize.max) {
                        records = records.filter(
                            (item) =>
                                item.lotSqFt >= parseInt(filterRef.current.lotSize.min) &&
                                item.lotSqFt <= parseInt(filterRef.current.lotSize.max)
                        );
                    } else if (filterRef.current.lotSize.min) {
                        records = records.filter((item) => item.lotSqFt >= parseInt(filterRef.current.lotSize.min));
                    } else if (filterRef.current.lotSize.max) {
                        records = records.filter((item) => item.lotSqFt <= parseInt(filterRef.current.lotSize.max));
                    }
                }
                if (filterRef.current.stories) {
                    if (filterRef.current.stories.min && filterRef.current.stories.max) {
                        records = records.filter(
                            (item) =>
                                item.numberOfStories >= parseInt(filterRef.current.stories.min) &&
                                item.numberOfStories <= parseInt(filterRef.current.stories.max)
                        );
                    } else if (filterRef.current.stories.min) {
                        records = records.filter(
                            (item) => item.numberOfStories >= parseInt(filterRef.current.stories.min)
                        );
                    } else if (filterRef.current.stories.max) {
                        records = records.filter(
                            (item) => item.numberOfStories <= parseInt(filterRef.current.stories.max)
                        );
                    }
                }
                if (filterRef.current.yearBuilt) {
                    if (filterRef.current.yearBuilt.min && filterRef.current.yearBuilt.max) {
                        records = records.filter(
                            (item) =>
                                item.yearBuilt &&
                                parseInt(item.yearBuilt) >= parseInt(filterRef.current.yearBuilt.min) &&
                                parseInt(item.yearBuilt) <= parseInt(filterRef.current.yearBuilt.max)
                        );
                    } else if (filterRef.current.yearBuilt.min) {
                        records = records.filter(
                            (item) =>
                                item.yearBuilt && parseInt(item.yearBuilt) >= parseInt(filterRef.current.yearBuilt.min)
                        );
                    } else if (filterRef.current.yearBuilt.max) {
                        records = records.filter(
                            (item) =>
                                item.yearBuilt && parseInt(item.yearBuilt) <= parseInt(filterRef.current.yearBuilt.max)
                        );
                    }
                }
                if (filterRef.current.status?.length > 0) {
                    records = records.filter(
                        (item) => item.webListingStatus && filterRef.current.status.indexOf(item.webListingStatus) > -1
                    );
                }
                console.log("records", records);
                if (filterRef.current.leaseProduct?.length > 0) {
                    records = records.filter(
                        (item) => item.leaseType && filterRef.current.leaseProduct.indexOf(item.leaseType) > -1
                    );
                }
            }

            //let recordsData = sortRecords([...records]);
            return records;
        }
        return [];
    };

    const handleSortSelect = (value) => {
        setSelectedSorting(value);
    };

    const handleListingSelect = (value) => {
        let env = process.env.REACT_APP_ENV ? "/" + process.env.REACT_APP_ENV : "";
        window.open(env + "/property/" + value.id, "_blank");
    };

    let body = (
        <Box className="Search" sx={{ color: config.brandColor, marginTop: { xs: "75px", md: "48px", lg: "0px" } }}>
            {status === "succeeded" && (
                <>
                    <Box sx={{ flexGrow: 1, overflowX: "clip" }}>
                        <Grid container spacing={2}>
                            <Grid
                                item
                                lg={5}
                                lgx={6}
                                xs={12}
                                sx={{
                                    margin: "0px",
                                    paddingBottom: "0px",
                                    paddingTop: { xs: "0px", lg: "inherit" },
                                    paddingRight: { xs: "0px", lg: "inherit" },
                                    marginTop: { xs: "-7px", lg: "0px" },
                                }}>
                                <Map
                                    ref={mapInstanceRef}
                                    zoom={zoom}
                                    onMapLocationChange={handleMapLocationChange}
                                    onMapRefChange={handleMapRef}
                                    coordinates={coordinates}
                                    locations={getRecords()}
                                    onMarkerSelect={handleMarkerSelect}
                                    onRefresh={(data) => {
                                        setMepRefresh(data);
                                    }}
                                    dimensions={
                                        !isDesktop && (isMobile || isTablet || isPortrait)
                                            ? { width: "100%", height: "calc(50vh - 75px)" }
                                            : { width: "100%", height: "calc(100vh - 70px)" }
                                    }></Map>
                            </Grid>
                            <Grid
                                item
                                lg={7}
                                lgx={6}
                                xs={12}
                                className="location-container"
                                sx={{ ml: { xs: "0px !important", lg: "-8px" } }}>
                                <Box className="heading">
                                    Pathway Homes in{" "}
                                    <b>
                                        {filters.market || market
                                            ? location?.formatted_address?.split(",")[0]
                                            : "National View"}
                                    </b>
                                </Box>
                                <Box sx={{ mt: "1rem" }}>
                                    <Filters
                                        selectedMarketRecord={selectedMarketRecordRef.current}
                                        markets={data?.markets}
                                        records={data?.records ? data?.records : []}
                                        onLocationChange={handleSelectedLocation}
                                        onChange={handleFilterChange}
                                        existingFilters={filterRef.current}
                                        propertyCount={properties ? properties.length : 0}></Filters>
                                </Box>

                                <Stack spacing={2}>
                                    {displayLocations && (
                                        <Location
                                            locations={[...properties]}
                                            onSelectListing={handleListingSelect}
                                            onSortSelect={handleSortSelect}
                                            selectedSorting={selectedSorting}
                                            sortOptions={getSortOptions()}
                                            selectedMarketRecord={selectedMarketRecordRef.current}
                                        />
                                    )}
                                </Stack>
                            </Grid>
                        </Grid>
                    </Box>
                </>
            )}
        </Box>
    );

    return getPageContent(body, status, error);
};

export { Search };
